import styled from 'styled-components'

export const FuelTableContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 1rem;
  ${(props) => props.theme.container};
  table {
    margin-top: 1rem;
  }
`
export const FuelConsumptionPeridContainer = styled.div`
  max-width: 280px;
  min-width: 280px;
  height: 2rem;
  display: flex;
  border-radius: 7px;
  overflow: hidden;
  ${(props) => props.theme.content};
`

export const ConsumptionPeriodButton = styled.div<{ active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  ${(props) => props.active && 'background-color:#ff9900; color:white !important;'}
  font-size: 10.5px;
  cursor: pointer;
`

export const FuelDashboardRow = styled.div<{ mb?: string }>`
  display: flex;
  width: 100%;
  gap: 1rem;
  ${(props) => props.mb && 'margin-bottom:' + props.mb + ';'}

  @media (max-width: 1120px) {
    flex-direction: column;
  }
`
